// Voice UI text lives in the LangContext dictionaries, section `v` (keys
// prefixed with "voice"). This maps saga/helper codes to those keys.

export const voiceText = (i18n, key) => (i18n && i18n.v && i18n.v[key]) || key

export const DISABLED_REASON_KEYS = {
  notRegistered: 'voiceNotRegistered',
  anotherCall: 'voiceAnotherCallActive',
  inCall: 'voiceInCall',
  vehicleBusy: 'voiceVehicleBusy',
  vehicleOffline: 'voiceVehicleOffline',
}
